import classnames from 'classnames';
import { CSSProperties } from 'react';

import styles from './loader.module.scss';

type Props = {
    className?: CSSProperties;
    size?: number;
    color?: string;
};

const Loader = ({ size = 48, className, color }: Props) => (
    <span
        className={classnames({
            ...className,
            [styles.loader]: true,
        })}
        style={{
            height: size,
            width: size,
            borderWidth: size * 0.12,
            borderColor: color ?? '#525d72',
            borderBottomColor: 'transparent',
        }}
    />
);

export default Loader;
